import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { cloudloyalty } from "Services/Apis/clients";

export const addToWishListThunk = createAsyncThunk(
  "wishList/addToWishListThunk",
  async (productSku, { getState, rejectWithValue }) => {
    try {
      const { user } = getState().oidc;

      return cloudloyalty(user).put(`/v1/participants/me/wishlist/${productSku}/add`, {});
    } catch (err) {
      console.log(err);
      return rejectWithValue(err);
    }
  }
)

export const removeFromWishListThunk = createAsyncThunk(
  "wishList/removeFromWishListThunk",
  async (productSku, { getState, rejectWithValue }) => {
    try {
      const { user } = getState().oidc;

      return cloudloyalty(user).delete(`/v1/participants/me/wishlist/${productSku}/remove`, {});
    } catch (err) {
      console.log(err);
      return rejectWithValue(err);
    }
  }
)

export const getWishListThunk = createAsyncThunk(
  "wishList/getWishListThunk",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { user } = getState().oidc;

      const { data } = await cloudloyalty(user).get("/v1/participants/me/wishlist");

      return data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err);
    }
  }
)

export const getSimpleWishListThunk = createAsyncThunk(
  "simpleWishlist/getSimpleWishListThunk",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { user } = getState().oidc;
      if (user && user?.access_token ) {
        const { data } = await cloudloyalty(user).get("/v1/participants/me/simplewishlist");
        return data;
      }
      console.error(`Erro: Dados do usuário não carregado`);
      return rejectWithValue('');
    } catch (err) {
      console.log(err);
      return rejectWithValue(err);
    }
  }
)

const initialState = {
  wishListData: [],
  simpleWishListData: [],
  isFetchingWishList: false,
  isFetchingSimpleWishList: false,
  isAddingToWishList: false,
  isRemovingFromWishList: false,
  fetchWishListHasError: false,
  fetchSimpleWishListHasError: false,
  addToWishListHasError: false,
  removeFromWishListHasError: false,
};

const WishListSlice = createSlice({
  name: "getSimpleWishList",
  initialState,
  reducers: {
    resetWishListData: (state) => {
      state.wishListData = initialState.wishListData;
      state.simpleWishListData = initialState.simpleWishListData;
      state.isFetchingWishList = initialState.isFetchingWishList;
      state.isAddingToWishList = initialState.isAddingToWishList;
      state.isRemovingFromWishList = initialState.isRemovingFromWishList;
      state.fetchWishListHasError = initialState.fetchWishListHasError;
      state.addToWishListHasError = initialState.addToWishListHasError;
      state.removeFromWishListHasError = initialState.removeFromWishListHasError;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getWishListThunk.pending, (state) => {
      state.isFetchingWishList = true;
      state.fetchWishListHasError = false;
    })

    builder.addCase(getWishListThunk.fulfilled, (state, action) => {
      state.wishListData = action.payload;
      state.isFetchingWishList = false;
      state.fetchWishListHasError = false;
    })

    builder.addCase(getWishListThunk.rejected, (state, action) => {
      state.isFetchingWishList = false;
      state.fetchWishListHasError = action.payload;
    })

    builder.addCase(getSimpleWishListThunk.pending, (state) => {
      state.isFetchingSimpleWishList = true;
      state.fetchSimpleWishListHasError = false;
    })

    builder.addCase(getSimpleWishListThunk.fulfilled, (state, action) => {
      state.simpleWishListData = action.payload;
      state.isFetchingSimpleWishList = false;
      state.fetchSimpleWishListHasError = false;
    })

    builder.addCase(getSimpleWishListThunk.rejected, (state, action) => {
      state.isFetchingSimpleWishList = false;
      state.fetchSimpleWishListHasError = action.payload;
    })

    builder.addCase(addToWishListThunk.pending, (state) => {
      state.isAddingToWishList = true;
      state.addToWishListHasError = false;
    })

    builder.addCase(addToWishListThunk.fulfilled, (state) => {
      state.isAddingToWishList = false;
      state.addToWishListHasError = false;
    })

    builder.addCase(addToWishListThunk.rejected, (state, action) => {
      state.isAddingToWishList = false;
      state.addToWishListHasError = action.payload;
    })

    builder.addCase(removeFromWishListThunk.pending, (state) => {
      state.isRemovingFromWishList = true;
      state.removeFromWishListHasError = false;
    })

    builder.addCase(removeFromWishListThunk.fulfilled, (state) => {
      state.isRemovingFromWishList = false;
      state.removeFromWishListHasError = false;
    })

    builder.addCase(removeFromWishListThunk.rejected, (state, action) => {
      state.isRemovingFromWishList = false;
      state.removeFromWishListHasError = action.payload;
    })
  }
})

export const { resetWishListData } = WishListSlice.actions;
export default WishListSlice.reducer;
